// "use client";

// import React, { useState } from "react";
// import Image from "next/image";
// import { motion } from "framer-motion";
// import ReactMarkdown from "react-markdown";

// interface Founder {
//   id: number;
//   name: string;
//   about: string;
//   designation: string;
//   picture: {
//     data: {
//       attributes: {
//         url: string;
//         alternativeText: string | null;
//       };
//     };
//   };
// }

// interface TeamProps {
//   data: {
//     title: string;
//     founders: Founder[];
//     useH1Tag?: boolean;
//   };
// }

// // Helper function to extract highlights from about text
// const extractHighlights = (about: string): string[] => {
//   if (!about) return [];
  
//   const lines = about.split('\n');
//   const highlightsIndex = lines.findIndex(line => line.trim() === 'Key Highlights');
  
//   if (highlightsIndex === -1) return [];
  
//   const highlights: string[] = [];
//   for (let i = highlightsIndex + 1; i < lines.length; i++) {
//     const line = lines[i].trim();
//     if (line === '') break;
//     const cleanedLine = line.replace(/^-\s*(\d+\.\s*)?/, '').trim();
//     highlights.push(cleanedLine);
//   }
  
//   return highlights;
// };

// export default function Team_Home_Layout1({ data }: TeamProps) {
//   const [selected, setSelected] = useState<Founder | null>(null);

//   return (
//     <>
//       <section className="relative py-16 bg-[#FAF8F4] text-green-900 overflow-hidden">
//         {/* Top & bottom borders */}
//         {/* <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#EAE5DC] via-green-900 to-[#EAE5DC]" /> */}
//         {/* <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-[#EAE5DC] via-green-900 to-[#EAE5DC]" /> */}

//         {/* Decorative blobs */}
//         {/* <div className="absolute -right-40 -top-40 w-[480px] h-[480px] rounded-full bg-green-900/10 backdrop-blur-[80px]" /> */}
//         {/* <div className="absolute -left-40 -bottom-40 w-[520px] h-[520px] rounded-full bg-green-900/10 backdrop-blur-[80px]" /> */}

//         <div className="max-w-5xl mx-auto px-4 sm:px-6 relative z-10">
//           {/* Section header */}
//           <motion.header
//             className="text-center max-w-3xl mx-auto mb-12"
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.6 }}
//             viewport={{ once: true }}
//           >
//             {/* <motion.span
//               className="inline-block px-4 py-1 text-xs font-medium tracking-widest rounded-full bg-[#EAE5DC] text-green-900 mb-4"
//               initial={{ scale: 0.9 }}
//               whileInView={{ scale: 1 }}
//               transition={{ duration: 0.5 }}
//             >
//               OUR LEADERSHIP TEAM
//             </motion.span> */}

//             {data.useH1Tag ? (
//               <h1 className="text-3xl  font-bold text-black-900 mb-4">
//                 {data.title}
//               </h1>
//             ) : (
//               <h2 className="text-3xl  font-bold text-black-900 mb-4">
//                 {data.title}
//               </h2>
//             )}
//           </motion.header>

//           {/* Cards list */}
//           <div className="space-y-8">
//             {data.founders.map((f) => {
//               const highlights = extractHighlights(f.about);
//               const aboutWithoutHighlights = f.about.split('Key Highlights')[0].trim();
              
//               return (
//                 <motion.div
//                   key={f.id}
//                   className="relative isolate overflow-hidden bg-white rounded-2xl shadow-lg border border-green-100 hover:shadow-xl transition-all"
//                   initial={{ opacity: 0, y: 20 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   transition={{ duration: 0.6 }}
//                   viewport={{ once: true }}
//                 >
//                   <div className="absolute inset-0 -z-10 bg-gradient-to-br from-[#f5f1e9]/20 to-white" />
//                   <div className="absolute -right-10 -top-10 w-32 h-32 rounded-full bg-green-900/10 blur-xl" />

//                   <div className="grid grid-cols-1 md:grid-cols-4 gap-6 p-6">
//                     {/* Image */}
//                     <div className="md:col-span-1 relative">
//                       <div className="aspect-square relative overflow-hidden rounded-xl shadow-md">
//                         <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent z-10" />
//                         <Image
//                           src={f.picture.data.attributes.url}
//                           alt={f.picture.data.attributes.alternativeText || f.name}
//                           fill
//                           className="object-cover"
//                           sizes="(max-width: 768px) 100vw, 25vw"
//                         />
//                       </div>
//                     </div>

//                     {/* Content */}
//                     <div className="md:col-span-3 flex flex-col justify-center">
//                       <div className="flex flex-wrap items-center gap-3 mb-3">
//                         <h3 className="text-xl  font-medium text-green-900">
//                           {f.name}
//                         </h3>
//                         <span className="text-xs font-medium bg-green-900 text-white px-2 py-1 rounded-full">
//                           {f.designation}
//                         </span>
//                       </div>

//                       <ReactMarkdown className="prose prose-sm text-gray-700 ">
//                         {aboutWithoutHighlights}
//                       </ReactMarkdown>

//                       {highlights.length > 0 && (
//                         <>
//                           <h4 className="text-xs uppercase tracking-wider text-gray-600 mb-2 font-medium">
//                             Key Highlights
//                           </h4>
//                           <ul className="grid grid-cols-2 gap-2 mb-4">
//                             {highlights.slice(0, 4).map((feat, i) => (
//                               <li
//                                 key={i}
//                                 className="flex items-center text-sm text-gray-700"
//                               >
//                                 <svg
//                                   className="flex-shrink-0 h-4 w-4 text-green-900 mr-2"
//                                   fill="currentColor"
//                                   viewBox="0 0 20 20"
//                                 >
//                                   <path
//                                     fillRule="evenodd"
//                                     d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
//                                     clipRule="evenodd"
//                                   />
//                                 </svg>
//                                 {feat}
//                               </li>
//                             ))}
//                           </ul>
//                         </>
//                       )}

//                       <button
//                         onClick={() => setSelected(f)}
//                         className="mt-auto self-start px-4 py-2 bg-green-900 text-white text-sm rounded-lg hover:bg-green-800 transition-colors"
//                       >
//                         Show More
//                       </button>
//                     </div>
//                   </div>
//                 </motion.div>
//               );
//             })}
//           </div>
//         </div>
//       </section>

//       {/* Details Modal */}
//       {selected && (
//         <div
//           className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
//           onClick={() => setSelected(null)}
//         >
//           <div
//             className="bg-white rounded-lg shadow-xl w-11/12 max-w-md max-h-[90vh] overflow-y-auto p-4 relative"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <button
//               className="absolute top-2 right-2 text-gray-500 hover:text-gray-800 text-lg"
//               onClick={() => setSelected(null)}
//             >
//               ×
//             </button>

//             <div className="text-center mb-4">
//               <Image
//                 src={selected.picture.data.attributes.url}
//                 alt={selected.picture.data.attributes.alternativeText || selected.name}
//                 width={100}
//                 height={100}
//                 className="rounded-full object-cover shadow-sm mx-auto"
//               />
//               <h3 className="text-lg font-semibold text-green-900 mt-2">
//                 {selected.name}
//               </h3>
//               <span className="inline-block text-xs font-medium bg-green-900 text-white px-2 py-1 rounded-full mt-1">
//                 {selected.designation}
//               </span>
//             </div>

//             <div className="prose prose-sm text-gray-700 mb-4">
//               <ReactMarkdown>{selected.about.split('Key Highlights')[0].trim()}</ReactMarkdown>
//             </div>

//             <h4 className="text-xs uppercase tracking-wider text-gray-600 mb-2 font-medium">
//               Key Highlights
//             </h4>
//             <ul className="list-disc list-inside space-y-1 text-sm text-gray-700">
//               {extractHighlights(selected.about).map((feat, i) => (
//                 <li key={i}>{feat}</li>
//               ))}
//             </ul>
//           </div>
//         </div>
//       )}
//     </>
//   );
// }

// "use client";

// import React, { useState } from "react";
// import Image from "next/image";
// import { motion } from "framer-motion";
// import ReactMarkdown from "react-markdown";

// interface Founder {
//   id: number;
//   name: string;
//   about: string;
//   designation: string;
//   picture: {
//     data: {
//       attributes: {
//         url: string;
//         alternativeText: string | null;
//       };
//     };
//   };
// }

// interface TeamProps {
//   data: {
//     title: string;
//     founders: Founder[];
//     useH1Tag?: boolean;
//   };
// }

// export default function Team_Home_Layout1({ data }: TeamProps) {
//   const [selected, setSelected] = useState<Founder | null>(null);

//   // Predefined highlights per founder (index-based)
//   const founderHighlights: Record<number, string[]> = {
//     0: [
//       "Over five decades of unmatched expertise in apparel and denim mastery.",
//       "Guiding light and visionary mentor of CrunchyFashion.",
//       "Holds a Master’s in Science, blending knowledge, skill, and foresight.",
//       "Unwavering commitment of 50+ years inspiring new generations.",
//     ],
//     1: [
//       "30+ years of expertise in denim craftsmanship and apparel leadership.",
//       "Graduate of Shri Ram College of Commerce.",
//       "Relentless pursuit of perfection with intuitive market insight.",
//       "A strong pillar driving CrunchyFashion’s consistency and credibility.",
//     ],
//     2: [
//       "CEO & Director with 30+ years of denim and apparel expertise.",
//       "B.Com (Hons.) from Delhi University + specialization in Clothing Management from IIFT.",
//       "Blends sharp business acumen with forward-looking vision.",
//       "Architect of CrunchyFashion’s global positioning in sustainable denim fashion.",
//     ],
//     3: [
//       "Youngest founder and CTO with 8 years of fashion-tech experience.",
//       "B.Tech graduate driving innovation at the intersection of fashion & technology.",
//       "Leads AI-driven design and sustainability practices.",
//       "Brings youthful energy ensuring CrunchyFashion speaks the language of modern fashion.",
//     ],
//   };

//   return (
//     <>
//       <section className="relative py-16 bg-[#FAF8F4] text-black overflow-hidden">
//         <div className="max-w-5xl mx-auto px-4 sm:px-6 relative z-10">
//           {/* Section header */}
//           <motion.header
//             className="text-center max-w-3xl mx-auto mb-12"
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.6 }}
//             viewport={{ once: true }}
//           >
//             {data.useH1Tag ? (
//               <h1 className="text-3xl font-bold text-black-900 mb-4">
//                 {data.title}
//               </h1>
//             ) : (
//               <h2 className="text-3xl font-bold text-black-900 mb-4">
//                 {data.title}
//               </h2>
//             )}
//           </motion.header>

//           {/* Cards list */}
//           <div className="space-y-8">
//             {data.founders.map((f, index) => {
//               return (
//                 <motion.div
//                   key={f.id}
//                   className="relative isolate overflow-hidden bg-white rounded-2xl shadow-lg border border-black hover:shadow-xl transition-all"
//                   initial={{ opacity: 0, y: 20 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   transition={{ duration: 0.6 }}
//                   viewport={{ once: true }}
//                 >
//                   <div className="absolute inset-0 -z-10 bg-gradient-to-br from-[#f5f1e9]/20 to-white" />
//                   <div className="absolute -right-10 -top-10 w-32 h-32 rounded-full bg-black/10 blur-xl" />


//                   <div className="grid grid-cols-1 md:grid-cols-4 gap-6 p-6">
//                     {/* Image */}
//                     <div className="md:col-span-1 relative">
//                       <div className="aspect-square relative overflow-hidden rounded-xl shadow-md">
//                         <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent z-10" />
//                         <Image
//                           src={f.picture.data.attributes.url}
//                           alt={
//                             f.picture.data.attributes.alternativeText || f.name
//                           }
//                           fill
//                           className="object-cover"
//                           sizes="(max-width: 768px) 100vw, 25vw"
//                         />
//                       </div>
//                     </div>

//                     {/* Content */}
//                     <div className="md:col-span-3 flex flex-col justify-center">
//                       <div className="flex flex-wrap items-center gap-3 mb-3">
//                         <h3 className="text-xl font-medium text-black">
//                           {f.name}
//                         </h3>
//                         <span className="text-xs font-medium bg-black text-white px-2 py-1 rounded-full">
//                           {f.designation}
//                         </span>
//                       </div>

//                       {/* Preview text with line clamp */}
//                       <p className="text-gray-700 text-sm line-clamp-3">
//                         {f.about.split("Key Highlights")[0].trim()}
//                       </p>

//                       {/* Inject highlights if defined */}
//                       {founderHighlights[index] && (
//                         <>
//                           <h4 className="text-xs uppercase tracking-wider text-gray-600 mb-2 font-medium mt-3">
//                             Key Highlights
//                           </h4>
//                           <ul className="grid grid-cols-2 gap-2 mb-4">
//                             {founderHighlights[index].map((feat, i) => (
//                               <li
//                                 key={i}
//                                 className="flex items-center text-sm text-gray-700"
//                               >
//                                 <svg
//                                   className="flex-shrink-0 h-4 w-4 text-black mr-2"
//                                   fill="currentColor"
//                                   viewBox="0 0 20 20"
//                                 >
//                                   <path
//                                     fillRule="evenodd"
//                                     d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
//                                     clipRule="evenodd"
//                                   />
//                                 </svg>
//                                 {feat}
//                               </li>
//                             ))}
//                           </ul>
//                         </>
//                       )}

//                       <button
//                         onClick={() => setSelected(f)}
//                         className="mt-auto self-start px-4 py-2 bg-black text-white text-sm rounded-lg hover:bg-black transition-colors"
//                       >
//                         Show More
//                       </button>
//                     </div>
//                   </div>
//                 </motion.div>
//               );
//             })}
//           </div>
//         </div>
//       </section>

//       {/* Details Modal */}
//       {selected && (
//         <div
//           className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
//           onClick={() => setSelected(null)}
//         >
//           <div
//             className="bg-white rounded-lg shadow-xl w-11/12 max-w-md max-h-[90vh] overflow-y-auto p-4 relative"
//             onClick={(e) => e.stopPropagation()}
//           >
//             {/* Close button */}
//             <button
//               className="absolute top-2 right-2 text-gray-500 hover:text-gray-800 text-lg"
//               onClick={() => setSelected(null)}
//             >
//               ×
//             </button>

//             <div className="text-center mb-4">
//               <Image
//                 src={selected.picture.data.attributes.url}
//                 alt={
//                   selected.picture.data.attributes.alternativeText ||
//                   selected.name
//                 }
//                 width={100}
//                 height={100}
//                 className="rounded-full object-cover shadow-sm mx-auto"
//               />
//               <h3 className="text-lg font-semibold text-black mt-2">
//                 {selected.name}
//               </h3>
//               <span className="inline-block text-xs font-medium bg-black text-white px-2 py-1 rounded-full mt-1">
//                 {selected.designation}
//               </span>
//             </div>

//             <div className="prose prose-sm text-gray-700 mb-4">
//               <ReactMarkdown>
//                 {selected.about.split("Key Highlights")[0].trim()}
//               </ReactMarkdown>
//             </div>

//             {/* Show correct highlights from predefined list */}
//             {(() => {
//               const index = data.founders.findIndex((f) => f.id === selected.id);
//               const highlights = founderHighlights[index];

//               return (
//                 highlights && (
//                   <>
//                     <h4 className="text-xs uppercase tracking-wider text-gray-600 mb-2 font-medium">
//                       Key Highlights
//                     </h4>
//                     <ul className="list-disc list-inside space-y-1 text-sm text-gray-700">
//                       {highlights.map((feat, i) => (
//                         <li key={i}>{feat}</li>
//                       ))}
//                     </ul>
//                   </>
//                 )
//               );
//             })()}
//           </div>
//         </div>
//       )}
//     </>
//   );
// }


"use client";

import React, { useState } from "react";
import Image from "next/image";
import { motion } from "framer-motion";
import ReactMarkdown from "react-markdown";

interface Founder {
  id: number;
  name: string;
  about: string;
  designation: string;
  picture: {
    data: {
      attributes: {
        url: string;
        alternativeText: string | null;
      };
    };
  };
}

interface TeamProps {
  data: {
    title: string;
    founders: Founder[];
    useH1Tag?: boolean;
  };
}

// ✅ Improved extractor for Strapi multiline text
const extractHighlights = (about: string): string[] => {
  if (!about) return [];

  // Normalize line endings and split
  const lines = about.replace(/\r/g, "").split("\n");

  // Find the Key Highlights section (with or without colon)
  const highlightsIndex = lines.findIndex((line) =>
    line.trim().toLowerCase().startsWith("key highlights")
  );

  if (highlightsIndex === -1) return [];

  const highlights: string[] = [];

  // Loop through lines after "Key Highlights"
  for (let i = highlightsIndex + 1; i < lines.length; i++) {
    const line = lines[i].trim();

    // Stop at blank line or next paragraph
    if (!line || /^[A-Za-z]/.test(line)) break;

    // Match any bullet type (-, •, –, etc.)
    const match = line.match(/^[\-\–•]\s*(.+)/);
    if (match) {
      highlights.push(match[1].trim());
    }
  }

  return highlights;
};

export default function Team_Home_Layout1({ data }: TeamProps) {
  const [selected, setSelected] = useState<Founder | null>(null);

  return (
    <>
      <section className="relative py-16 bg-[#FAF8F4] text-black overflow-hidden">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 relative z-10">
          {/* Section Header */}
          <motion.header
            className="text-center max-w-3xl mx-auto mb-12"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            {data.useH1Tag ? (
              <h1 className="text-3xl font-bold mb-4">{data.title}</h1>
            ) : (
              <h2 className="text-3xl font-bold mb-4">{data.title}</h2>
            )}
          </motion.header>

          {/* Founder Cards */}
          <div className="space-y-8">
            {data.founders.map((f) => {
              const highlights = extractHighlights(f.about);
              const aboutText = f.about.split(/Key Highlights/i)[0].trim();

              return (
                <motion.div
                  key={f.id}
                  className="relative isolate overflow-hidden bg-white rounded-2xl shadow-lg border border-black hover:shadow-xl transition-all"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  viewport={{ once: true }}
                >
                  <div className="absolute inset-0 -z-10 bg-gradient-to-br from-[#f5f1e9]/20 to-white" />
                  <div className="absolute -right-10 -top-10 w-32 h-32 rounded-full bg-black/10 blur-xl" />

                  <div className="grid grid-cols-1 md:grid-cols-4 gap-6 p-6">
                    {/* Image */}
                    <div className="md:col-span-1 relative">
                      <div className="aspect-square relative overflow-hidden rounded-xl shadow-md">
                        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent z-10" />
                        <Image
                          src={f.picture.data.attributes.url}
                          alt={
                            f.picture.data.attributes.alternativeText || f.name
                          }
                          fill
                          className="object-cover"
                          sizes="(max-width: 768px) 100vw, 25vw"
                        />
                      </div>
                    </div>

                    {/* Content */}
                    <div className="md:col-span-3 flex flex-col justify-center">
                      <div className="flex flex-wrap items-center gap-3 mb-3">
                        <h3 className="text-xl font-medium text-black">
                          {f.name}
                        </h3>
                        <span className="text-xs font-medium bg-black text-white px-2 py-1 rounded-full">
                          {f.designation}
                        </span>
                      </div>

                      {/* Short About Text */}
                      <p className="text-gray-700 text-sm line-clamp-3">
                        {aboutText}
                      </p>

                      {/* Dynamic Highlights */}
{highlights.length > 0 && (
  <>
    <h4 className="text-xs uppercase tracking-wider text-[#534365] mb-2 font-medium mt-3">
      Key Highlights
    </h4>
    <ul className="grid grid-cols-2 gap-y-3 gap-x-6 mb-4">
      {highlights.slice(0, 4).map((feat, i) => (
        <li
          key={i}
          className="flex items-start gap-2 text-sm text-[#534365] leading-snug"
        >
          <svg
            className="flex-shrink-0 w-4 h-4 text-black mt-1"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
              clipRule="evenodd"
            />
          </svg>
          <span className="block">{feat}</span>
        </li>
      ))}
    </ul>
  </>
)}


                      <button
                        onClick={() => setSelected(f)}
                        className="mt-auto self-start px-4 py-2 bg-black text-white text-sm rounded-lg hover:bg-neutral-900 transition-colors"
                      >
                        Show More
                      </button>
                    </div>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Modal for Full Details */}
      {selected && (
        <div
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
          onClick={() => setSelected(null)}
        >
          <div
            className="bg-white rounded-lg shadow-xl w-11/12 max-w-md max-h-[90vh] overflow-y-auto p-4 relative"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-800 text-lg"
              onClick={() => setSelected(null)}
            >
              ×
            </button>

            <div className="text-center mb-4">
              <Image
                src={selected.picture.data.attributes.url}
                alt={
                  selected.picture.data.attributes.alternativeText ||
                  selected.name
                }
                width={100}
                height={100}
                className="rounded-full object-cover shadow-sm mx-auto"
              />
              <h3 className="text-lg font-semibold text-black mt-2">
                {selected.name}
              </h3>
              <span className="inline-block text-xs font-medium bg-black text-white px-2 py-1 rounded-full mt-1">
                {selected.designation}
              </span>
            </div>

            <div className="prose prose-sm text-gray-700 mb-4">
              <ReactMarkdown>
                {selected.about.split(/Key Highlights/i)[0].trim()}
              </ReactMarkdown>
            </div>

            {/* Dynamic Highlights inside Modal */}
            {extractHighlights(selected.about).length > 0 && (
              <>
                <h4 className="text-xs uppercase tracking-wider text-gray-600 mb-2 font-medium">
                  Key Highlights
                </h4>
                <ul className="list-disc list-inside space-y-1 text-sm text-gray-700">
                  {extractHighlights(selected.about).map((feat, i) => (
                    <li key={i}>{feat}</li>
                  ))}
                </ul>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}
